module.exports = __webpack_public_path__ + "assets/img/al.b348f515.svg";